// extracted by mini-css-extract-plugin
export default {"root":"Spinner_root__A7ur0","disc":"Spinner_disc__KPvU0","spinnerRotate":"Spinner_spinnerRotate__U62uD","label":"Spinner_label__eSGjs"};